import addClass from './addClass';
import hasClass from './hasClass';
import removeClass from './removeClass';

// ----------------------------------------------------------------------------

function toggleClass(element: HTMLElement, token: string, value?: boolean): boolean {
    if (typeof value != 'boolean') {
        value = !hasClass(element, token);
    }

    //
    if (value) {
        addClass(element, token);
    }
    //
    else {
        removeClass(element, token);
    }

    //
    return value;
}

// ----------------------------------------------------------------------------

export default toggleClass;
